import React from 'react';

export const DateRangeAnswerField = ({
	startValue,
	endValue,
	onStartChange,
	onEndChange
}) => {
	
	return (
		<div className="row">
			<div className="col-6 col-sm-3">
				<input type="date"
					className='form-control w-auto'
					value={startValue}
					max={endValue}
					id="dateResponseStart"
					onChange={(e) => onStartChange(e.target.value)}/>
			</div>
			<div className="col-6 col-sm-3">
				<input type="date"
					className='form-control w-auto'
					value={endValue}
					id="toDateResponse"
					min={startValue}
					onChange={(e) => onEndChange(e.target.value)}/>
			</div>
		</div>
	);
};

export default DateRangeAnswerField;
